<div class="small-container">
  <div class="text">
    Upload a logo:
    <div class="info">
      Upload any Image OR<br />
      Video with alpha transparency.
    </div>
  </div>

  <icn-drag-public-media
    [media]="packshotUrl"
    (mediaChange)="onPackshotUrlChange($event)"
  ></icn-drag-public-media>
</div>
<div class="container" *ngIf="packshotUrl && packshotUrl.length > 0">
  <div>Define logo position:</div>
  <div class="advanced-settings">
    <evrideo-graphics-rectangle-f
      *ngIf="logoRectangleFVM"
      [vm]="logoRectangleFVM"
    ></evrideo-graphics-rectangle-f>
    <evrideo-layer-input
      [(zIndex)]="logoZIndex"
      (zIndexChange)="onLogoZIndexChange($event)"
    ></evrideo-layer-input>
  </div>
</div>
<div class="small-container">
  <div class="text">
    Upload a place-holder image:
    <div class="info">
      This image will be displayed when<br />
      there's an empty slot in your broadcast.
    </div>
  </div>
  <icn-drag-image
    [thumbnail]="placeholderImage"
    (thumbnailChange)="onPlaceholderImageChange($event)"
  ></icn-drag-image>
</div>
